'use client'
import React, { useState, useEffect, useRef } from 'react'
import intlTelInput from 'intl-tel-input'
import { useDisclosure } from '@mantine/hooks';
import 'intl-tel-input/build/css/intlTelInput.css'
import {
    Box,
    Button,
    Flex,
    BackgroundImage,
    Switch,
    Text,
    rem,
    TextInput,
    LoadingOverlay,
    Image,
    Drawer,
    Group, ActionIcon, Container, createStyles, useMantineTheme
} from '@mantine/core'
import Head from 'next/head'
import { register, agentRegister, sendCode } from '@/api'
import { useRouter } from 'next/router'
import { useTranslation } from 'react-i18next'
import { ToastContainer, toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import { useMutation } from 'react-query'
import HashSvg from "@/assets/HASHMiner.svg";
import {
    IconBrandFacebook,
    IconBrandInstagram,
    IconBrandLinkedin, IconBrandTelegram, IconBrandTiktok,
    IconBrandTwitter, IconBrandWhatsapp,
    IconBrandYoutube,
    IconMail
} from "@tabler/icons-react";


const languages = [
    {
        name: 'English',
        key: 'en'
    },
    {
        name: '繁體中文',
        key: 'zh'
    },
    {
        name: 'русский',
        key: 'ru'
    }
]

const useStyles = createStyles((theme) => ({
    footer: {
        // marginTop: rem(120),
        // borderTop: `${rem(1)} solid ${
        //     theme.colorScheme === 'dark' ? theme.colors.dark[5] : theme.colors.gray[2]
        // }`,
    },

    inner: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        paddingTop: theme.spacing.xl,
        paddingBottom: theme.spacing.xl,

        // [theme.fn.smallerThan('xs')]: {
        //     flexDirection: 'column',
        // },
    },

    links: {
        [theme.fn.smallerThan('xs')]: {
            // marginTop: theme.spacing.md,
        },
    },
}));

const PhoneNumberInput = ({ onAreaCodesChange }: { onAreaCodesChange: (codes: string[]) => void }) => {
    const inputRef = useRef(null)

    useEffect(() => {
        const excludedCountries = ['tw', 'hk', 'mo', 'cn']

        // @ts-ignore
        const iti = intlTelInput(inputRef.current, {
            initialCountry: '',
            preferredCountries: ['us', 'ua', 'au', 'kg'],
            excludeCountries: excludedCountries,
            placeholderNumberType: 'FIXED_LINE',
        })

        const handleInputChange = () => {
            const areaCodes = iti.getSelectedCountryData().dialCode
            const inputElement = document.querySelector('input[type="text"]') as HTMLInputElement
            const phoneNumber = inputElement.value
            onAreaCodesChange([areaCodes, phoneNumber])
        }

        // @ts-ignore
        inputRef.current.addEventListener('change', handleInputChange)
    }, [onAreaCodesChange])

    return <input ref={inputRef} type="text" style={{ width: '100%', height: '100%' }} />
}

export default function join() {
    const router = useRouter()
    const { classes } = useStyles()
    const theme = useMantineTheme()
    const { t, i18n } = useTranslation()

    const handleClick = (link: string) => {
        window.open(link, "_blank")
    }

    const [opened, { open, close }] = useDisclosure(false)
    const [emailOrMobile, setEmailOrMobile] = useState('')
    const [language, setLanguage] = useState(i18n.language)
    const [codeType, setCodeType] = useState('register_phone')
    const [registerType, setRegisterType] = useState('2')
    const [password, setPassword] = useState('')
    const [verifyCode, setVerifyCode] = useState('')
    const [confirmPassword, setConfirmPassword] = useState('')
    const [isChecked, setIsChecked] = useState(false)
    const [showAreaCode, setShowAreaCode] = useState(false)
    const [areaCodes, setAreaCodes] = useState('')
    const [isCodeSending, setIsCodeSending] = useState(false) // 添加倒计时状态
    const [countdown, setCountdown] = useState(60) // 倒计时时间



    const { mutate: registerMutate, isLoading: registerIsLoading } = useMutation(register, {
        onSuccess: (data) => {
                toast.success(String(t('registrationSuccessfulMessage')), {
                    position: "top-center",
                    autoClose: 1000,
                })
                setTimeout(() => {
                    router.push('/').then(r => r)
                }, 1000)
            }
    })

    const { mutate: agentRegisterMutate, isLoading: agentRegisterIsLoading } = useMutation(agentRegister, {
        onSuccess: (data) => {
            toast.success(String(t('registrationSuccessfulMessage')), {
                position: "top-center",
                autoClose: 1000,
            })
            setTimeout(() => {
                router.push('/').then(r => r)
            }, 1000)
        }
    })

    const { mutate: sendCodeMutate, isLoading: sendCodeIsLoading } = useMutation(sendCode, {
        onSuccess: (data) => {
                toast.success(String(t('sentSuccessfullyMessage')), {
                    position: "top-center",
                    autoClose: 3000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "light",
                })
                setIsCodeSending(true) // 开始倒计时
                setCountdown(60) // 设置倒计时时间
        }
    })


    const handleAreaCodesChange = (codes: string[]) => {
        setEmailOrMobile(codes[1])
        const acc = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(codes[1])
        // const inputElement = document.querySelector('input[type="text"]') as HTMLInputElement
        if (acc) {
            setRegisterType('1')
            setCodeType('register_email')
        } else {
            setRegisterType('2')
            setCodeType('register_phone')
        }
        if (codes[0] !== undefined) {
            setAreaCodes('+' + codes[0])
        }
    }

    const handleChange = () => {
        setIsChecked(!isChecked)
    }

    const handleCodeType = (e: { target: { value: any } }) => {
        setVerifyCode(e.target.value)
    }

    // const handleRegisterType = (e: { target: { value: any } }) => {
    //     setRegisterType(e.target.value)
    // }

    const handlePassword = (e: { target: { value: any } }) => {
        setPassword(e.target.value)
    }

    const handleConfirmPassword = (e: { target: { value: any } }) => {
        setConfirmPassword(e.target.value)
    }

    const handleGetCode = async (e: { preventDefault: () => void }) => {
        e.preventDefault()
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
        const mobileRegex = /^\d{6,}$/

        let isValid = false

        if (emailRegex.test(emailOrMobile)) {
            isValid = true
        } else if (mobileRegex.test(emailOrMobile)) {
            isValid = true
        }

        if (isValid) {
            sendCodeMutate({
                codeType: codeType,
                areaCode: areaCodes,
                registerType: registerType,
                emailOrMobile: emailOrMobile
            })
        } else {
            toast.warning(String(t('invalidFormatMessage')), {
                position: "top-center",
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
            })
        }
    }

    useEffect(() => {
        let timer: string | number | NodeJS.Timeout | undefined
        if (isCodeSending) {
            timer = setInterval(() => {
                setCountdown((prevCountdown: number) => {
                    if (prevCountdown === 1) {
                        setIsCodeSending(false) // 倒计时结束，重置倒计时状态
                        clearInterval(timer)
                        return 60
                    }
                    return prevCountdown - 1
                })
            }, 1000)
        }
        return () => {
            clearInterval(timer)
        }
    }, [isCodeSending])


    const onSubmit = async (e: { preventDefault: () => void }) => {
        e.preventDefault()
        if (!emailOrMobile) {
            toast.warning(String(t('invalidFormatMessage')), { position: "top-center", autoClose: 3000, })
            return
        }
        if (!verifyCode) {
            toast.warning(String(t('enterVerificationCodeMessage')), { position: "top-center", autoClose: 3000, })
            return
        }
        const passwordPattern = /^(?=.*[A-Za-z]).{9,16}$/
        if (!passwordPattern.test(password)) {
            toast.warning(String(t('passwordRequirementsMessage')), {
                position: 'top-center',
                autoClose: 3000,
            })
            return
        }

        if (password !== confirmPassword) {
            toast.warning(String(t('passwordMismatchMessage')), {
                position: 'top-center',
                autoClose: 3000,
            })
            return
        }

        if (!isChecked) {
            toast.warning(String(t('acceptAgreementMessage')), {
                position: 'top-center',
                autoClose: 3000,
            })
            return
        }

        if (router.query.ag) {
            agentRegisterMutate({
                areaCode: areaCodes,
                registerType: registerType,
                emailOrMobile: emailOrMobile,
                password: password,
                confirmPassword: confirmPassword,
                verifyCode: verifyCode,
                ...(router.query.ag && { extendCode: String(router.query.ag) })
            })
        }else {
            registerMutate({
                areaCode: areaCodes,
                registerType: registerType,
                emailOrMobile: emailOrMobile,
                password: password,
                confirmPassword: confirmPassword,
                verifyCode: verifyCode,
                ...(router.query.id && { extendCode: String(router.query.id) })
            })
        }


    }

    const handleLinkClick = (event: { preventDefault: () => void }) => {
        router.push('/privacyPolicy').then(r => r)
    }

    const switchLanguages = (key: string) => {
        setLanguage(key)
        i18n.changeLanguage(key).then(r => r)
        close()
    }


    return (
        <Flex style={{ display: 'flex', width: '100%' }}>
            <Head>
                <meta name="viewport" content="width=device-width, initial-scale=1, maximum-scale=1, user-scalable=no" />
                <meta name="theme-color" content="#1F1E1B" />
                <title></title>
            </Head>
            <Box bg="#1F1E1B" style={{ maxWidth: '428px', width: '100%', height: '100vh', margin: '0 auto' }}>

                <Flex className="absolute top-40" align="center" style={{
                    backgroundColor: '#FBBF24',
                    width:"2rem",
                    height:"2rem",
                    borderTopRightRadius: "1.24rem",
                    borderBottomRightRadius: "1.24rem",
                    zIndex: 99
                }}
                      onClick={open}
                >
                    <Image src={`/join/${language}.svg`} width="1.8rem" height="1.8rem" radius="xl" />
                </Flex>

                <Drawer
                    opened={opened}
                    onClose={close}
                    size="10%"
                    position="top"
                    withCloseButton={false}
                    overlayProps={{ opacity: 0.5, blur: 4 }}
                >
                    <Flex align="center" justify="space-around">

                        {languages.map((language) => (
                            <Flex key={language.key} direction="column" align="center" onClick={() => switchLanguages(language.key)}>
                                <Image src={`/join/${language.key}.svg`} width="1.5rem" height="1.5rem" radius="xl" />
                                <Text color="#fff" mt=".6rem">{language.name}</Text>
                            </Flex>
                        ))}
                    </Flex>
                </Drawer>


                <LoadingOverlay visible={registerIsLoading || agentRegisterIsLoading || sendCodeIsLoading} overlayBlur={2} />
                <Box bg="#1F1E1B" h="auto" style={{ minHeight: '750px' }}>
                    <BackgroundImage src="/join/img.png" style={{ width: '100%', height: rem(214), position: 'relative' }}></BackgroundImage>
                    <ToastContainer />
                    <form onSubmit={onSubmit} style={{ padding: '0 15px', display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
                        <Box style={{ position: 'relative' }}>
                            <Text className="mantine-TextInput-label" color="#fff" style={{ fontWeight: 500 }}>
                                {t('emailOrPhoneLabel')} <span style={{ color: 'red' }}>*</span>
                            </Text>
                            {showAreaCode && (
                                <Text color="#475569" style={{ position: 'absolute', left: '12px', top: '55px', fontSize: '.9rem', fontWeight: '600' }}>
                                    {areaCodes}
                                </Text>
                            )}
                            <PhoneNumberInput onAreaCodesChange={handleAreaCodesChange} />
                            {!isCodeSending && (
                                <Text
                                    color="#475569"
                                    onClick={handleGetCode}
                                    style={{ position: 'absolute', right: '12px', top: '55px', fontSize: '.9rem', fontWeight: '600', cursor: 'pointer' }}
                                >
                                    {t('sendButtonText')}
                                </Text>
                            )}
                            {isCodeSending && (
                                <Text
                                    color="#475569"
                                    style={{ position: 'absolute', right: '12px', top: '55px', fontSize: '.9rem', fontWeight: '600' }}
                                >
                                    {countdown}
                                </Text>
                            )}
                        </Box>
                        <TextInput
                            name="verifyCode"
                            type="number"
                            placeholder={t('pleaseEnterCaptcha')}
                            onChange={handleCodeType}
                            withAsterisk
                            label={t('verificationCodeLabel')}
                            maxLength={6}
                        />

                        <TextInput
                            name="password"
                            type="password"
                            placeholder={t('passwordRequirements')}
                            onChange={handlePassword}
                            withAsterisk
                            label={t('passwordLabel')}
                        />
                        <TextInput
                            name="confirmPassword"
                            type="password"
                            placeholder={t('pleaseConfirmPassword')}
                            onChange={handleConfirmPassword}
                            withAsterisk
                            label={t('confirmPasswordLabel')}
                        />
                        <Flex style={{ margin: '20px 0' }} align="center">
                            <Switch checked={isChecked} onChange={handleChange} color="teal" size="md" />
                            <Text color="#fff" size="0.8rem" ml={2}>
                                {t('readAndAgreeLabel')}
                                <span style={{ color: '#FEE21F' }} onClick={handleLinkClick}>
                                    ({ t('termsOfServiceLink') })
                                </span>
                            </Text>
                        </Flex>
                        <Button type="submit" style={{ width: '100%', backgroundColor: '#FBBF24', height: '3rem', color: '#101010' }}>
                            {t('signupButton')}
                        </Button>
                    </form>

                    <Container className={classes.inner} style={{display: 'flex', justifyContent: 'center'}}>
                        <Group spacing={0} className={classes.links} position="right" noWrap>
                            <ActionIcon size="lg" onClick={()=> handleClick('mailto:heyingsg@gmail.com')} >
                                <IconMail size="1.05rem" stroke={1.5} />
                            </ActionIcon>
                            <ActionIcon size="lg" onClick={()=> handleClick('https://www.facebook.com/profile.php?id=61550848753292')}>
                                <IconBrandFacebook size="1.05rem" stroke={1.5} />
                            </ActionIcon>
                            <ActionIcon size="lg" onClick={()=> handleClick('https://twitter.com/@HashMiner358119')}>
                                <IconBrandTwitter size="1.05rem" stroke={1.5} />
                            </ActionIcon>
                            {/*<ActionIcon size="lg">*/}
                            {/*    <IconBrandYoutube size="1.05rem" stroke={1.5} />*/}
                            {/*</ActionIcon>*/}
                            {/*<ActionIcon size="lg">*/}
                            {/*    <IconBrandLinkedin size="1.05rem" stroke={1.5} />*/}
                            {/*</ActionIcon>*/}
                            <ActionIcon size="lg" onClick={()=> handleClick('https://www.instagram.com/hashminer50')}>
                                <IconBrandInstagram size="1.05rem" stroke={1.5} />
                            </ActionIcon>
                            <ActionIcon size="lg" onClick={()=> handleClick('https://www.tiktok.com/@hashminer4')}>
                                <IconBrandTiktok size="1.05rem" stroke={1.5} />
                            </ActionIcon>
                            <ActionIcon size="lg" onClick={()=> handleClick('https://wa.me/+16262130612')}>
                                <IconBrandWhatsapp size="1.05rem" stroke={1.5} />
                            </ActionIcon>
                            <ActionIcon size="lg" onClick={()=> handleClick('https://t.me/HashMiner01')}>
                                <IconBrandTelegram size="1.05rem" stroke={1.5} />
                            </ActionIcon>
                        </Group>
                    </Container>
                </Box>
            </Box>
        </Flex>
    )
}
